var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vms__preloader"},[_c('div',{staticClass:"vms__preloader-span vms__OpenSansRegular"},[_vm._v(" "+_vm._s(_vm.$t('ui.uiPreloader') || 'Loading')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }